// ** React Imports
import { useEffect } from 'react'

// ** Next Imports
import { useRouter } from 'next/router'

// ** Spinner Import
import Spinner from 'src/@core/components/spinner'

// ** Hook Imports
import { useAuth } from 'src/hooks/useAuth'
import axiosInstance from 'src/services/serverAxios'
import toast from 'react-hot-toast'
import { useMediaQuery, useTheme } from '@mui/material'

/**
 *  Set Home URL
 */
const getHomeRoute = (isMobile: boolean) => {
  return isMobile ? '/home-page' : '/dashboards'
}

const Home = () => {
  // Vars for breakpoint mobile
  const theme = useTheme()
  const smDownBreakpoint = useMediaQuery(theme.breakpoints.down('sm'))

  // ** Hooks
  const auth = useAuth()
  const router = useRouter()

  // ** Catch 401 errors
  axiosInstance.interceptors.response.use(
    function (response) {
      return response
    },
    function (error) {
      if (error.response?.status === 401) {
        // Show a toast message to the user
        toast.error('Your session has expired. Please sign in again.')

        // Log the user out
        auth.logout()

        // Redirect to the login page
        router.replace('/login')
      }

      return Promise.reject(error)
    }
  )

  useEffect(() => {
    if (!router.isReady) {
      return
    }

    if (auth.user) {
      const homeRoute = getHomeRoute(smDownBreakpoint)

      // Redirect user to Home URL
      router.replace(homeRoute)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.isReady, smDownBreakpoint, auth.user])

  return <Spinner />
}

export default Home
